import { render, staticRenderFns } from "./ListParticipantsBrain.vue?vue&type=template&id=7bdd2d01&scoped=true"
import script from "./ListParticipantsBrain.vue?vue&type=script&lang=js"
export * from "./ListParticipantsBrain.vue?vue&type=script&lang=js"
import style0 from "./ListParticipantsBrain.vue?vue&type=style&index=0&id=7bdd2d01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdd2d01",
  null
  
)

export default component.exports